import { render, staticRenderFns } from "./PlanListPage.vue?vue&type=template&id=01595412&"
import script from "./PlanListPage.vue?vue&type=script&lang=ts&"
export * from "./PlanListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports